"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
const finley_types_1 = require("@finley-technologies/finley-types");
const consts = __importStar(require("../consts"));
// @jen placeholder schema + validator
const Version1Point0Validate = (test) => {
    if (test) {
        return true;
    }
    return { errors: [] };
};
const Version1Point0 = {
    validate: Version1Point0Validate,
};
const Version = {
    [finley_types_1.CreditAgreement.DomainEntity.CreditAgreementSchemaVersion['1.0']]: Version1Point0,
};
const validate = (test, schemaVersion) => {
    switch (schemaVersion) {
        case finley_types_1.CreditAgreement.DomainEntity.CreditAgreementSchemaVersion['1.0']:
            return Version[finley_types_1.CreditAgreement.DomainEntity.CreditAgreementSchemaVersion['1.0']].validate(test);
        default:
            // if no schema version provided, assumes current schema version
            return Version[finley_types_1.CreditAgreement.DomainEntity.CreditAgreementSchemaVersion[consts.CURRENT_CREDIT_AGREEMENT_DOCUMENT_SCHEMA_VERSION]].validate(test);
    }
};
exports.validate = validate;
//# sourceMappingURL=creditAgreementFullArtifact.js.map